import { ModularComponent as MC } from '@modular-component/core'
import {
  addTo,
  ModularContext,
  StageReturn
} from '@modular-component/core/extend'
import '@modular-component/default/register'
import { useStore } from '@nanostores/react'
import { $view, actions } from '../state/view.ts'
import { $chatView } from '../state/chat.ts'
import { $screen } from '../state/screen.ts'

export const ModularComponent = <P extends {}>(displayName?: string) =>
  MC<P>(displayName).withView().withAct().withScreen()

const Modular = {
  view: <Context extends ModularContext>() =>
    addTo<Context>()
      .on('view')
      .provide(() => useStore($view)),
  chat: <Context extends ModularContext>() =>
    addTo<Context>()
      .on('chat')
      .provide(() => useStore($chatView)),
  screen: <Context extends ModularContext>() =>
    addTo<Context>()
      .on('screen')
      .provide(() => useStore($screen)),
  act: <Context extends ModularContext>() =>
    addTo<Context>()
      .on('act')
      .provide(() => actions)
}

MC.register(Modular)

type WithView<Context extends ModularContext> = () => StageReturn<
  typeof Modular.view<Context>
>
type WithChat<Context extends ModularContext> = () => StageReturn<
  typeof Modular.chat<Context>
>
type WithScreen<Context extends ModularContext> = () => StageReturn<
  typeof Modular.screen<Context>
>
type WithAct<Context extends ModularContext> = () => StageReturn<
  typeof Modular.act<Context>
>

declare module '@modular-component/stages' {
  export interface ModularComponentStages<Context extends ModularContext> {
    withView: WithView<Context>
    withChat: WithChat<Context>
    withScreen: WithScreen<Context>
    withAct: WithAct<Context>
  }
}

export default Modular
